<template>
	<div class="costomer">
		<div class="container">
			<div class="content">
				<p>以售后服务为切入点，打造技术服务领域解决产品销售、配送安装、维修保养、紧急救援全方位跨行业的大型综合类的技术服务平台。目前天图极客平台已开通的服务类目有多种：
					安防、IT、汽车维护
				</p>
				<p>以售后服务为切入点，打造技术服务领域解决产品销售、配送安装、维修保养、紧急救援全方位跨行业的大型综合类的技术服务平台。目前天图极客平台已开通的服务类目有多种：
					安防、IT、汽车维护
				</p>
				
				<p>以售后服务为切入点，打造技术服务领域解决产品销售、配送安装、维修保养、紧急救援全方位跨行业的大型综合类的技术服务平台。目前天图极客平台已开通的服务类目有多种：
					安防、IT、汽车维护
				</p>
				
				
				<p>以售后服务为切入点，打造技术服务领域解决产品销售、配送安装、维修保养、紧急救援全方位跨行业的大型综合类的技术服务平台。目前天图极客平台已开通的服务类目有多种：
					安防、IT、汽车维护
				</p>
				
				<p>以售后服务为切入点，打造技术服务领域解决产品销售、配送安装、维修保养、紧急救援全方位跨行业的大型综合类的技术服务平台。目前天图极客平台已开通的服务类目有多种：
					安防、IT、汽车维护
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'',
		conponents:{},
		data(){
			return{
				msg:'costomer'
			}
		}
	}
	
</script>

<style lang="less" scoped="scoped">
.costomer{
	margin-top: 70px;
	.content{
		p{
			font-size: 15px;
			margin-bottom: 35px;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/ServiceCenter/Scom/Costomer.vue